module.exports = __webpack_public_path__ + "static/pic03-07580b45958767e7f90516b58401e04c.jpg";